module.exports = __webpack_public_path__ + "static/media/video.3d64a42e.mov";